import { useEffect, useState } from 'react'

const checkTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0

export function useIsTouchDevice() {
  const [isTouchDevice, setIsTouchDevice] = useState<boolean>(checkTouchDevice())

  useEffect(() => {
    const updateState = () => setIsTouchDevice(checkTouchDevice())

    window.addEventListener('touchstart', updateState)
    window.addEventListener('mousedown', updateState)
    window.addEventListener('resize', updateState)

    return () => {
      window.removeEventListener('touchstart', updateState)
      window.removeEventListener('mousedown', updateState)
      window.removeEventListener('resize', updateState)
    }
  }, [])

  return isTouchDevice
}
